var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboshop-widget"},[_c('SiteLogo',{staticClass:"h-auto w-16"}),_vm._v(" "),_c('a',{attrs:{"href":"/aboshop","target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.$t('aboshopWidget.buttonText'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }